export interface WebsiteConfig {
  title: string;
  callNumber: number;
  Email: string;
  description: string;
  keyword: string;
  coverImage?: string;
  logo: string;
  /**
   * Specifying a valid BCP 47 language helps screen readers announce text properly.
   * See: https://dequeuniversity.com/rules/axe/2.2/valid-lang
   */
  lang: string;
  /**
   * blog full path, no ending slash!
   */
  siteUrl: string;
  /**
   * full url, no username
   */
  blogUrl: string;
  /**
   * full url, no username
   */
   linktree?: string;
   /**
    * full url, no username
    */
  facebook?: string;
  /**
   * full url, no username
   */
  instagram?: string;
  /**
   * full url, no username
   */
  linkedin?: string;
  /**
   * full url, no username
   */
   youtube?: string;
  /**
   * full url, no username
   */
   github?: string;
  /**
   * full url, no username
   */
   pinterest?: string;
  /**
   * full url, no username
   */

  twitter?: string;
  /**
   * hide or show all email subscribe boxes
   */
  showSubscribe: boolean;
  /**
   * create a list on mailchimp and then create an embeddable signup form. this is the form action
   */
  mailchimpAction?: string;
  /**
   * this is the hidden input field name
   */
  mailchimpName?: string;
  /**
   * name and id of the mailchimp email field
   */
  mailchimpEmailFieldName?: string;
  /**
  /**
   * Meta tag for Google Webmaster Tools
   */
  googleSiteVerification?: string;
  /**
  /**
   * Appears alongside the footer, after the credits
   */
  footer?: string;
}

const config: WebsiteConfig = {
  title: 'Website Design Company: Website designing & Website Development Company in Delhi (Best Wordpress and Web Development Company in Delhi)',
  callNumber: 9999757799,
  Email:'bizdamn@gmail.com',
  description: 'Website Design Company: Bizdamn is a Leading and most Trusted Web and Wordpress Development Company in Delhi offering attractive website designing services. We Design Responsive & Search Engine Friendly Website. Call +91- 9999757799.Best Wordpress Development Company in Delhi.',
  keyword: 'Best Wordpress and Web Development Services in Delhi, Website Designing Company in Laxmi Nagar, Web Development Company in Delhi, Best Ecommerce Website Designing Company in Delhi, Top Web Designing Company in Delhi, Website designing company, Web development company, Wordpress Development company, Web Development Agency, Web Development firms, Web Development consultancy, Web Development company in Delhi NCR, Wordpress Website company',
  coverImage: 'img/Branding-Cover.jpg',
  logo: 'BizdamnLogo.svg',
  lang: 'en',
  siteUrl: 'https://bizdamn.tech',
  linktree: 'https://bizdamn.tech/contact-links',
  blogUrl: 'https://bizdamn.tech/blog',
  facebook: 'https://www.facebook.com/bizdamncompany',
  instagram: 'https://www.instagram.com/bizdamn/',
  linkedin: 'https://www.linkedin.com/company/bizdamn',
  youtube: 'https://www.youtube.com/channel/UCGsL-IDxqNd7GDBw_eyCAzg',
  github: 'https://github.com/bizdamn',
  pinterest: 'https://www.pinterest.com/bizdamn',
  twitter: 'https://twitter.com/biz_damn',
  showSubscribe: true,
  mailchimpAction: 'https://tech.us6.list-manage.com/subscribe/post?u=e0afcea882ae6b9249d6e5f17&amp;id=11d689d3da',
  
  mailchimpName: 'b_a89b6987ac248c81b0b7f3a0f_7d777b7d75',
  mailchimpEmailFieldName: 'MERGE0',
  googleSiteVerification: 'GoogleCode',
  footer: '',
};

export default config;
